import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';

export const businessPartnersPlansHeaders: Record<string, EnhancedTableHeader> =
  {
    businessPartner_Code: {
      name: 'businessPartner_Code',
      title: 'Business Partner Code',
      type: EnhancedTableHeaderType.Text,
    },
    person_FullName: {
      name: 'person_FullName',
      title: 'Business Partner Name',
      type: EnhancedTableHeaderType.Clickable,
      callback: () => undefined,
    },
    line_ExternalCode: {
      name: 'line_ExternalCode',
      title: 'Line Code',
      type: EnhancedTableHeaderType.Text,
    },
    line_Name: {
      name: 'line_Name',
      title: 'Line',
      type: EnhancedTableHeaderType.Clickable,
      callback: () => undefined,
    },
    plan_ExternalCode: {
      name: 'plan_ExternalCode',
      title: 'Plan Code',
      type: EnhancedTableHeaderType.Text,
    },
    plan_Name: {
      name: 'plan_Name',
      title: 'Plan',
      type: EnhancedTableHeaderType.Clickable,
      callback: () => undefined,
    },
    salesforceManagement_AssignedBPPlan_Status: {
      name: 'salesforceManagement_AssignedBPPlan_Status',
      title: '',
      type: EnhancedTableHeaderType.Image,
      hasConditionalImage: true,
      variableOneImageKey:
        'https://ufa-cdn.baibars.club/ufa-app-portal/images/green-correct-img.png',
      variableTwoImageKey:
        'https://ufa-cdn.baibars.club/ufa-app-portal/images/red-clean-img.png',
    },
  };

export function filterSectionsContent(
  lovs: Record<string, Record<string, string>>,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: '',
      inputs: {
        bp: {
          name: 'bp',
          title: '',
          type: FormInputTypes.chips,
          value: filterValues?.bp || [],
          placeholder: 'Filter By Business Partner',
          triggerUpdate: true,
          selectOptions: { ...lovs.bp },
        },
        line: {
          name: 'line',
          title: '',
          type: FormInputTypes.chips,
          value: filterValues?.line || [],
          placeholder: 'Filter By Line',
          triggerUpdate: true,
          selectOptions: { ...lovs.line },
        },
        plan: {
          name: 'plan',
          title: '',
          type: FormInputTypes.chips,
          value: filterValues?.plan || [],
          placeholder: 'Filter By Plan',
          triggerUpdate: true,
          selectOptions: { ...lovs.plan },
        },
      },
    },
  ];
  return newFilterSections;
}
